import { CandidateService } from "@/services/candidateService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchCandidateAnalysis = createAsyncThunk("candidateAnalysis/fetch", async (params, thunkAPI) => {
  try {
    return await CandidateService.fetchAnalysis(params);
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch analysis");
  }
});

export const silentRefetchCandidateAnalysis = createAsyncThunk("candidateAnalysis/silentRefetch", async (params, thunkAPI) => {
  try {
    return await CandidateService.fetchAnalysis(params);
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to refetch analysis");
  }
});

const initialState = {
  data: null,
  loading: false,
  error: null,
  currentStatus: "",
  // Tracks which candidate `data` belongs to. Used by the UI to detect
  // "stale" data (e.g. switching from candidate A to B while A's data
  // is still in the store) so it can show a skeleton instead of A's
  // details under B's id.
  dataCandidateId: null,
};

const candidateAnalysisSlice = createSlice({
  name: "candidateAnalysis",
  initialState,
  reducers: {
    updateCandidateStatusLocally: (state, action) => {
      state.currentStatus = action.payload;
      if (state.data?.candidate_details) {
        state.data.candidate_details.status = action.payload;
      }
    },
    clearCandidateAnalysis: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.currentStatus = "";
      state.dataCandidateId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCandidateAnalysis.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCandidateAnalysis.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.currentStatus = action.payload?.candidate_details?.status ?? "";
        state.dataCandidateId = action.meta.arg?.candidateId ?? null;
      })
      .addCase(fetchCandidateAnalysis.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(silentRefetchCandidateAnalysis.fulfilled, (state, action) => {
        state.data = action.payload;
        state.currentStatus = action.payload?.candidate_details?.status ?? state.currentStatus;
        state.dataCandidateId = action.meta.arg?.candidateId ?? state.dataCandidateId;
      });
  },
});

export const { updateCandidateStatusLocally, clearCandidateAnalysis } = candidateAnalysisSlice.actions;

export default candidateAnalysisSlice.reducer;